import { createFileRoute } from "@tanstack/react-router";
import { SeoContentPage } from "@/components/SeoContentPage";
import { tennisTossApp } from "@/pages/seo-content";

const title = "App voor tennis toss – toss indelingen systeem & software | De Hussel App";
const description = "Tennis toss app voor automatische toss indelingen. Toss indelingen software die eerlijk rouleert, niveau meeweegt en spelers een melding stuurt.";

export const Route = createFileRoute("/tennis-toss-app")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/tennis-toss-app" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/tennis-toss-app" }],
  }),
  component: () => <SeoContentPage data={tennisTossApp} />,
});
